
const baseUrl = 'https://api.dogs.cyber-core.it';
//const baseUrl = 'http://localhost:8181';

const apiPaths = {

    // USER
    login: `${baseUrl}/auth/login`,
    getAllExampleElement: `${baseUrl}/element`,
    getAllUser: `${baseUrl}/user/list`,
    getUser: `${baseUrl}/me`,
    getAllUserByTenant:  `${baseUrl}/user/getUsers`,
    // da qui salvo gli utenti user dal Admin
    saveUserAdminToSuperAdmin: `${baseUrl}/user/admin`,
    saveUserNormal: `${baseUrl}/user/user-add`,
    deleteUser: `${baseUrl}/user/delete`,
    deleteAdmin: `${baseUrl}/user/delete-admin`,
    // update Super admin
    updateUser: `${baseUrl}/user/update`,
    // update admin
    updateAdmin: `${baseUrl}/user/update-admin`,
    allUserWithoutPaginable: `${baseUrl}/user/all`,
    filterUser: `${baseUrl}/user/search`,
    filterUserByTenant: `${baseUrl}/user/getUsers`,

    // TENANT
    saveTenant: `${baseUrl}/tenant`,
    updateTenant: `${baseUrl}/tenant/update`,
    allTenant: `${baseUrl}/tenant/all`,
    deleteTenant: `${baseUrl}/tenant/delete`,

    //ADOPTION
    saveAdoption: `${baseUrl}/adoption`,
    updateAdoption: `${baseUrl}/adoption/update`,
    allAdoption: `${baseUrl}/adoption/list`,
    deleteAdoption: `${baseUrl}/adoption/delete`,

    //DOG
    saveDog: `${baseUrl}/dog/`,
    updateDog: `${baseUrl}/dog/update`,
    allDog: `${baseUrl}/dog/list`,
    allDogDead: `${baseUrl}/dog/list-dead`,
    allDogAdopted: `${baseUrl}/dog/list-adopted`,
    allDogReturned: `${baseUrl}/dog/list-adopted`,
    deleteDog: `${baseUrl}/dog/delete`,
    allDogWithoutPaginable: `${baseUrl}/dog/all`,
    showDogWithoutBox:`${baseUrl}/dog/allDogWithoutDog`,
    filterDog: `${baseUrl}/dog/search`,
    filterDogDead: `${baseUrl}/dog/search/dead`,
    filterDogAdopted: `${baseUrl}/dog/search/adopted`,
    filterDogReturned: `${baseUrl}/dog/search/returned`,
    allDogWithMuniNotPageable: `${baseUrl}/dog/allDogMuniWithoutPag`,
    dogAction: `${baseUrl}/dog/action`,
    singleDog: `${baseUrl}/dog/first-dog`,
    filterDogList: `${baseUrl}/dog/list-dog-selected`,
    dogReport: `${baseUrl}/dog/count`,


    // MUNICIPALITY
    getAllMunicipality: `${baseUrl}/municipality/all`,
    deleteMunicipality: `${baseUrl}/municipality/delete`,
    updateMunicipality: `${baseUrl}/municipality/update`,
    saveMunicipality: `${baseUrl}/municipality/`,

    // SHED
    saveShed: `${baseUrl}/shed/`,
    allShed: `${baseUrl}/shed/list`,
    allShedNotPageable: `${baseUrl}/shed/all`,
    updateShed:`${baseUrl}/shed/update`,
    deleteShed: `${baseUrl}/shed/delete`,
    filterShed: `${baseUrl}/shed/search`,
    actionShed: `${baseUrl}/shed/action`,

    // TREAMENTS
    saveTreatments: `${baseUrl}/treatment/`,
    allTreatments: `${baseUrl}/treatment/list`,
    deleteTreatments:`${baseUrl}/treatment/delete`,
    updateTreatments:`${baseUrl}/treatment/update`,
    visualTreatmentExpired:`${baseUrl}/treatment/visualExpired`,
    setCheckComplete:`${baseUrl}/treatment/setExpiration`,


    // BOX
    saveBox: `${baseUrl}/box/`,
    allBox: `${baseUrl}/box/list`,
    allBoxWithoutPageable: `${baseUrl}/box/all`,
    deleteBox: `${baseUrl}/box/delete`,
    updateBox:  `${baseUrl}/box/update`,
    searchBox:  `${baseUrl}/box/search`,
    changeDogBox:  `${baseUrl}/box/addListIntoBox`,
    actionBox: `${baseUrl}/box/action`,




    // MULTIMEDIA
    saveMultimedia: `${baseUrl}/multimedia/`,
    allMultimedia: `${baseUrl}/multimedia/list`,
    deleteMultimedia: `${baseUrl}/multimedia/delete`,
};


export default apiPaths;